import { useQuery } from "@apollo/client";
import { FETCH_USER_PROFILE } from "@company/graphql/queries/fetchUserProfile";
import { Query } from "@/app/graphql/codegen";

/**
 * Hook to check if the current user is an admin.
 * @returns object with isAdmin boolean and loading state
 */
export const useIsAdmin = (): { isAdmin: boolean; loading: boolean } => {
  const { data, loading } = useQuery<Pick<Query, "userProfile">>(FETCH_USER_PROFILE);
  
  // Check if the user has admin privileges based on their role
  return {
    isAdmin: data?.userProfile?.role === "ADMIN",
    loading
  };
}; 